import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Grid,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Autocomplete,
} from "@mui/material";
import { editGuestDetail, getSalesOrderDetail, returnUpdate } from "../actions";
import Header from "../Components/header";
import NavigationButtons from "../Components/navigationButton";
import SectionForm from "../Components/sectionForm";
import { getPicklist, isDifferentValue, splitDateTime } from "../util/helpers";
import InputDate from "../../../components/global/InputDate";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { withTranslation } from "react-i18next";

const { URL_PREFIX } = window;

class VF2Step1 extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      isGetDataLoading: false,
      isOpen: false,
      form: {
        First_Name__c: "",
        Middle_Name__c: "",
        Last_Name__c: "",
        Salutation__c: "",
        Nick_Name__c: "",
        Birthdate__c: "",
        Guest_Gender__c: "",
        Nationality__c: "",
        Passport_Number__c: "",
        Passport_Expiry_Date__c: "",
        Email_Guest__c: "",
        Home_Tel__c: "",
        Mobile_Tel__c: "",
        How_did_you_find_us__c: "",
        Mailing_Country__c: "",
        Mailing_State_Province__c: "",
        Mailing_City__c: "",
        Mailing_Street__c: "",
        Mailing_Zip_Postal_Code__c: "",
        Emergency_Contact__c: "",
        Emergency_Tel__c: "",
        arrivalDate:"",
      },
      errors: {},
      passportWarningShown: false // Add this to track if warning was already shown
    };
  }

  componentDidMount() {
  // Initial check if `guestDetail` is already available
    const { guestDetail } = this.props.vf2;
    if (guestDetail) {
      this.updateFormState(guestDetail);
    }
  }

  componentDidUpdate(prevProps) {
    // Check if `guestDetail` was updated and update state accordingly
    if (prevProps.vf2.guestDetail !== this.props.vf2.guestDetail && this.props.vf2.guestDetail) {
      this.updateFormState(this.props.vf2.guestDetail);
    }
  }

  // Helper function to set state
  updateFormState(guestDetail) {
    this.setState({
      form: {
        First_Name__c: guestDetail.First_Name__c ?? '',
        Middle_Name__c: guestDetail.Middle_Name__c ?? '',
        Last_Name__c: guestDetail.Last_Name__c ?? '',
        Salutation__c: guestDetail.Salutation__c ?? '',
        Nick_Name__c: guestDetail.Nick_Name__c ?? '',
        Birthdate__c: guestDetail.Birthdate__c ?? '',
        Guest_Gender__c: guestDetail.Guest_Gender__c ?? '',
        Nationality__c: guestDetail.Nationality__c ?? '',
        Passport_Number__c: guestDetail.Passport_Number__c ?? '',
        Passport_Expiry_Date__c: guestDetail.Passport_Expiry_Date__c ?? '',
        arrivalDate: splitDateTime(guestDetail.Arrival_Date_Time__c, 'date') ?? '',
        Email_Guest__c: guestDetail.Email_Guest__c ?? '',
        Home_Tel__c: guestDetail.Home_Tel__c ?? '',
        Mobile_Tel__c: guestDetail.Mobile_Tel__c ?? '',
        How_did_you_find_us__c: guestDetail.How_did_you_find_us__c ?? '',
        Mailing_Country__c: guestDetail.Mailing_Country__c ?? '',
        Mailing_State_Province__c: guestDetail.Mailing_State_Province__c ?? '',
        Mailing_City__c: guestDetail.Mailing_City__c ?? '',
        Mailing_Street__c: guestDetail.Mailing_Street__c ?? '',
        Mailing_Zip_Postal_Code__c: guestDetail.Mailing_Zip_Postal_Code__c ?? '',
        Emergency_Contact__c: guestDetail.Emergency_Contact__c ?? '',
        Emergency_Tel__c: guestDetail.Emergency_Tel__c ?? '',
      },
    });
  }

  handleChange = (event) => {
    const { name, value } = event.target;

    const fieldValidations = {
      Email_Guest__c: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,  // Email regex
    };

    const fieldPattern = fieldValidations[name];
    const isValid = fieldPattern ? fieldPattern.test(value) : true;

    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        [name]: value,
      },
      errors: {
        ...prevState.errors,
        [name]: isValid ? '' : `${this.props.t("Please enter a valid")} ${name.replace(/__c$/, '').replace(/_/g, ' ').replace('Guest', '')}`,
      },
    }));
  };

  handleSave = async () => {
    this.setState({ isLoading: true });
    try {
      let payload = this.state.form;
      const {guestDetail} = this.props.vf2

      if(guestDetail.Guest_Visit_Form_2_Status__c === 'Not Started'){
        payload.Guest_Visit_Form_2_Status__c = 'Started'
      }

      delete payload.arrivalDate
      
      if(isDifferentValue(payload, guestDetail)){
        if(payload.Birthdate__c === '') payload.Birthdate__c = null
        if(payload.Passport_Expiry_Date__c === '') payload.Passport_Expiry_Date__c = null

        await this.props.editGuestDetail(payload, guestDetail.Id, this.props.returnUpdate, 'detail');
      }
    } catch (error) {
      let errorMessage = this.props.t("An unknown error occurred");
      if (error.response) {
        errorMessage = error.response.message || "Login failed"; // Server error
      } else if (error.message) {
        errorMessage = error.message; // Client-side or network error
      }
      Swal.fire({
        type: "error",
        title: "Oops...",
        text: `${this.props.t("Something went wrong!")} ${errorMessage}`,
      });
      return false
    } finally {
      this.setState({ isLoading: false });
    }
  };

  addMonths = (date, months) => {
    const result = new Date(date);
    result.setMonth(result.getMonth() + months);
    return result;
  };

  componentWillMount() {
  }

  // Add method to show passport expiry warning modal
  showPassportExpiryWarning = () => {
    Swal.fire({
      title: 'Passport Expiry Warning',
      html: `
        <div style="text-align: left; line-height: 1.6;">
          <p><strong>Please note:</strong></p>
          <p>Your passport expiry date is less than 6 months from your arrival date. Immigration may not allow entry.</p>
          <p><strong>We recommend renewing your passport before traveling.</strong></p>
        </div>
      `,
      icon: 'warning',
      confirmButtonText: 'I Understand',
      confirmButtonColor: '#f39c12',
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        popup: 'passport-warning-modal',
        title: 'passport-warning-title',
        htmlContainer: 'passport-warning-content'
      }
    });
  };

  // Add method to check passport expiry and show warning if needed
  checkPassportExpiry = () => {
    const { form } = this.state;
    
    if (form.Passport_Expiry_Date__c && 
        form.arrivalDate && 
        new Date(form.Passport_Expiry_Date__c) < this.addMonths(new Date(form.arrivalDate), 6)) {
      
      this.showPassportExpiryWarning();
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(prevState => ({
      form: { ...prevState.form, [name]: value }
    }), () => {
      // Check passport expiry after state update
      if (name === 'Passport_Expiry_Date__c' || name === 'arrivalDate') {
        setTimeout(() => this.checkPassportExpiry(), 100);
      }
    });
  };

  render() {
    const { describe, guestDetail, agentDetail } = this.props.vf2;
    const {form, errors} = this.state

    return (
      <>
        <div style={{ margin: "30px", position:'relative' }}>
          <Header 
            title={this.props.t("Personal Information")} 
            subtitle={this.props.t("We require some personal information from you")}
            selectedGuest={guestDetail}
            agent={agentDetail}
          />

          <SectionForm title={this.props.t("About You")} subtitle={this.props.t("We’d like to know more about you")}>
            <Grid container spacing={2} sx={{ padding: '10px 0' }}>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("First Name")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="First_Name__c"
                  placeholder={this.props.t("First Name")}
                  value={form.First_Name__c}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Middle Name")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("Middle Name")}
                  name="Middle_Name__c"
                  value={form.Middle_Name__c}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Last Name")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("Last Name")}
                  name="Last_Name__c"
                  value={form.Last_Name__c}
                  onChange={this.handleChange}
                />
              </Grid>

              <Grid item xs={2}>
                <Typography variant="body1">{this.props.t("Salutation")}</Typography>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    labelId="salutation-label"
                    name="Salutation__c"
                    value={form.Salutation__c || ''}
                    onChange={this.handleChange}
                    variant="outlined"
                    sx={{ marginTop: 0 }}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>{this.props.t("Salutation")}</MenuItem>
                    {getPicklist('Salutation__c', describe).map((value,i) => 
                      <MenuItem value={value} key={i}>{value}</MenuItem>  
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body1">{this.props.t("Preferred/Given Name")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("Preferred/Given Name")}
                  name="Nick_Name__c"
                  value={form.Nick_Name__c}
                  onChange={this.handleChange}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography variant="body1">{this.props.t("Date of Birth")}</Typography>
                <InputDate
                  sx={{ marginTop: 0 }}
                  name="Birthdate__c"
                  value={form.Birthdate__c ? dayjs(form.Birthdate__c) : null}
                  format={'DD-MMM-YYYY'}
                  onChange={(e) => 
                    this.handleChange({target: {name: 'Birthdate__c', value: dayjs(e.$d).format("YYYY-MM-DD")  
                  }})}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{this.props.t("Gender")}</Typography>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    labelId="gender-label"
                    name="Guest_Gender__c"
                    value={form.Guest_Gender__c || ''}
                    onChange={this.handleChange}
                    variant="outlined"
                    sx={{ marginTop: 0 }}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>{this.props.t("Select Gender")}</MenuItem>
                    {getPicklist('Guest_Gender__c', describe).map((value,i) => 
                      <MenuItem value={value} key={i}>{this.props.t(value)}</MenuItem>  
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Nationality")}</Typography>
                <FormControl variant="outlined" fullWidth>
                  <Autocomplete
                    options={getPicklist('Nationality__c', describe)}
                    name="Nationality__c"
                    value={form.Nationality__c}
                    onChange={(event, newValue) => {
                      this.setState((prevState) => ({
                        form: {
                          ...prevState.form,
                          Nationality__c: newValue,
                        },
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Country"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} style={{ fontSize: '16px' }}>
                        {option}
                      </li>
                    )}
                    disableClearable
                    isOptionEqualToValue={(option, value) => option === value}
                    getOptionLabel={(option) => option}
                    sx={{ marginTop: 0 }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Passport")} #</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={`${this.props.t("Passport")} #`}
                  name="Passport_Number__c"
                  value={form.Passport_Number__c}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Passport Expiry Date")}</Typography>
                <InputDate
                  sx={{ marginTop: 0 }}
                  name="Passport_Expiry_Date__c"
                  value={form.Passport_Expiry_Date__c ? dayjs(form.Passport_Expiry_Date__c) : null}
                  format={'DD-MMM-YYYY'}
                  onChange={(e) => 
                    this.handleChange({target: {name: 'Passport_Expiry_Date__c', value: dayjs(e.$d).format("YYYY-MM-DD")  
                  }})}
                />
              </Grid>
              {/* form.Passport_Expiry_Date__c form.arrivalDate   */}

              <Grid item xs={12}>
                {form.Passport_Expiry_Date__c &&
                form.arrivalDate &&
                new Date(form.Passport_Expiry_Date__c) < this.addMonths(new Date(form.arrivalDate), 6) && (
                  <Typography color="error" variant="body2">
                    Passport expiry date must be at least 6 months after arrival date.
                  </Typography>
                )}

                <Typography variant="body1" sx={{ color: 'red', marginBottom: '8px' }}>
                  {this.props.t("For entry to Indonesia, your passport MUST be valid for more than 6 months.")}
                </Typography>
              </Grid>

              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Email Address")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("Email Address")}
                  name="Email_Guest__c"
                  type="email"
                  value={form.Email_Guest__c}
                  onChange={this.handleChange}
                  error={!!errors.Email_Guest__c}
                  helperText={errors.Email_Guest__c}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Home Tel")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("Home Tel")}
                  type="number"
                  name="Home_Tel__c"
                  value={form.Home_Tel__c}
                  onChange={this.handleChange}
                  InputProps={{
                    inputProps: {
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      style: {
                        MozAppearance: 'textfield',
                      },
                    },
                    sx: {
                      '& input[type=number]': {
                        MozAppearance: 'textfield',
                      },
                      '& input[type=number]::-webkit-outer-spin-button': {
                        WebkitAppearance: 'none',
                        margin: 0,
                      },
                      '& input[type=number]::-webkit-inner-spin-button': {
                        WebkitAppearance: 'none',
                        margin: 0,
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Mobile Tel")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("Mobile Tel")}
                  type="number"
                  name="Mobile_Tel__c"
                  value={form.Mobile_Tel__c}
                  onChange={this.handleChange}
                  InputProps={{
                    inputProps: {
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      style: {
                        MozAppearance: 'textfield',
                      },
                    },
                    sx: {
                      '& input[type=number]': {
                        MozAppearance: 'textfield',
                      },
                      '& input[type=number]::-webkit-outer-spin-button': {
                        WebkitAppearance: 'none',
                        margin: 0,
                      },
                      '& input[type=number]::-webkit-inner-spin-button': {
                        WebkitAppearance: 'none',
                        margin: 0,
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">{this.props.t("How did you find us?")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("How did you find us?")}
                  name="How_did_you_find_us__c"
                  value={form.How_did_you_find_us__c}
                  onChange={this.handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1" sx={{ color: 'red' }}>
                  {this.props.t("Please be aware that there is only limited medical assistance in the resort, and no hospitals or doctors available in the area. We suggest you ask a doctor whether you are fit for travelling and diving.")}
                </Typography>
              </Grid>
            </Grid>
          </SectionForm>

          <SectionForm title={this.props.t("Address and Contact Details")} subtitle={this.props.t("Tell us where you currently live")}>
            <Grid container spacing={2} sx={{ padding: '10px 0' }}>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Country")}</Typography>
                <FormControl variant="outlined" fullWidth>
                  <Autocomplete
                    options={getPicklist('Mailing_Country__c', describe)}
                    name="Mailing_Country__c"
                    value={form.Mailing_Country__c}
                    onChange={(event, newValue) => {
                      this.setState((prevState) => ({
                        form: {
                          ...prevState.form,
                          Mailing_Country__c: newValue,
                        },
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={this.props.t("Select Country")}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} style={{ fontSize: '16px' }}>
                        {option}
                      </li>
                    )}
                    disableClearable
                    isOptionEqualToValue={(option, value) => option === value}
                    getOptionLabel={(option) => option}
                    sx={{ marginTop: 0 }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("State or Province")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("State or Province")}
                  name="Mailing_State_Province__c"
                  value={form.Mailing_State_Province__c}
                  onChange={this.handleChange}
                />
              </Grid>

              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("City")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("City")}
                  name="Mailing_City__c"
                  value={form.Mailing_City__c}
                  onChange={this.handleChange}
                />
              </Grid>

              <Grid item xs={8}>
                <Typography variant="body1">{this.props.t("Street Address")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("Street Address")}
                  name="Mailing_Street__c"
                  value={form.Mailing_Street__c}
                  onChange={this.handleChange}
                />
              </Grid>

              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Postal code / Zip")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("Postal code / Zip")}
                  name="Mailing_Zip_Postal_Code__c"
                  value={form.Mailing_Zip_Postal_Code__c}
                  onChange={this.handleChange}
                />
              </Grid>
            </Grid>
          </SectionForm>

          <SectionForm title="Emergency Contacts" subtitle="Make sure the contact numbers are active">
            <Grid container spacing={2} sx={{ padding: '10px 0' }}>
              <Grid item xs={6}>
                <Typography variant="body1">{this.props.t("Emergency Contact Name")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("Emergency Contact Name")}
                  name="Emergency_Contact__c"
                  value={form.Emergency_Contact__c}
                  onChange={this.handleChange}
                />
              </Grid>
              
              <Grid item xs={6}>
                <Typography variant="body1">{this.props.t("Telephone")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("Telephone")}
                  name="Emergency_Tel__c"
                  value={form.Emergency_Tel__c}
                  onChange={this.handleChange}
                  type="tel" // Use type="tel" for telephone input
                />
              </Grid>
            </Grid>
          </SectionForm>

          <NavigationButtons 
            nextUrl={`${URL_PREFIX}/vf2/wizard/diving`} 
            backUrl={`${URL_PREFIX}/vf2/wizard`} 
            onSave={this.handleSave} 
            isLoading={this.state.isLoading} 
            showSave
            showBack={this.props.mainContact}
            showNext // Change to false to hide the Next button
          />
         
        </div >

      </>
    );
  }
}

VF2Step1.propTypes = {
  vf2: PropTypes.object.isRequired,
  // nextStep: PropTypes.func.isRequired,
  // previousStep: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      editGuestDetail,
      getSalesOrderDetail,
      returnUpdate,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  vf2: state.vf2,
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VF2Step1));
